import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";
import { useChat } from "@/context/ChatContext";

export default function PrivacyModal() {
  const { privacyOpen, setPrivacyOpen } = useChat();
  const [wa, setWa] = useState("");
  const [busy, setBusy] = useState(false);

  async function requestDeletion(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/privacy/delete-request", { whatsapp: wa });
      toast.success(`${data.message} Registros excluídos: ${data.deleted}.`);
      setWa("");
    } catch (err) {
      toast.error(formatApiError(err, "Não foi possível processar agora. Tente de novo."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={privacyOpen} onOpenChange={setPrivacyOpen}>
      <DialogContent className="max-h-[85vh] overflow-y-auto rounded-3xl sm:max-w-lg" data-testid="privacy-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold text-slate-900">
            Política de Privacidade e LGPD
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Como seus dados são tratados neste site, com transparência.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-sm leading-relaxed text-slate-600">
          <p>
            <strong className="text-slate-800">Quais dados coletamos:</strong> nome, número de WhatsApp,
            respostas do questionário do chatbot e o conteúdo da conversa, quando você participa da
            simulação; ou nome, WhatsApp e mensagem, quando usa o formulário de contato.
          </p>
          <p>
            <strong className="text-slate-800">Para que usamos:</strong> exclusivamente para o
            atendimento sobre consórcio pela consultora Isabela Guedes — contato, qualificação do seu
            perfil e simulação oficial. Não vendemos nem compartilhamos seus dados com terceiros.
          </p>
          <p>
            <strong className="text-slate-800">Base legal:</strong> o seu consentimento, dado no
            checkbox do chat ou no envio do formulário. Você pode retirar o consentimento quando quiser.
          </p>
          <p>
            <strong className="text-slate-800">Seus direitos (LGPD):</strong> solicitar acesso,
            correção e exclusão dos seus dados. Use o formulário abaixo para pedir a exclusão dos
            registros vinculados ao seu número, ou escreva para a Isabela.
          </p>

          <form onSubmit={requestDeletion} className="rounded-2xl border border-slate-200 bg-slate-50 p-4" data-testid="lgpd-delete-form">
            <label htmlFor="lgpd-wa" className="mb-2 block text-xs font-bold uppercase tracking-wide text-slate-500">
              Pedir exclusão dos meus dados
            </label>
            <div className="flex gap-2">
              <Input
                id="lgpd-wa"
                data-testid="lgpd-whatsapp-input"
                required
                value={wa}
                onChange={(e) => setWa(e.target.value)}
                placeholder="Seu WhatsApp com DDD"
                inputMode="tel"
              />
              <button
                type="submit"
                data-testid="lgpd-delete-submit"
                disabled={busy}
                className="shrink-0 rounded-lg bg-brand-600 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-brand-700 disabled:opacity-60"
              >
                {busy ? "Enviando..." : "Excluir"}
              </button>
            </div>
          </form>

          <p className="text-xs text-slate-400">
            Dúvidas sobre privacidade: isaguedes1319@gmail.com
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
